import SecureLS from 'secure-ls';
import { Device } from "@/utils/Capacitor";
import { Preferences } from '@capacitor/preferences';

const ls = new SecureLS();

export const Storage = {
    getUser: async () => {
        try {
            if (await Device.getPlatform() === 'web') {
                return ls.get(`${process.env.VUE_APP_NAME_ID}_user`);
            } else {
                const { value } = await Preferences.get({ key: `${process.env.VUE_APP_NAME_ID}_user` });
                return value ? JSON.parse(value) : null;
            }
        } catch (error) {
            console.error('Error fetching user:', error);
            return null;
        }
    },
    setUser: async (user = null) => {
        try {
            if (await Device.getPlatform() === 'web') {
                ls.set(`${process.env.VUE_APP_NAME_ID}_user`, user);
            } else {
                await Preferences.set({
                    key: `${process.env.VUE_APP_NAME_ID}_user`,
                    value: JSON.stringify(user)
                });
            }
        } catch (error) {
            console.error('Error saving user:', error);
        }
    },
    getAccount: async () => {
        try {
            if (await Device.getPlatform() === 'web') {
                return ls.get(`${process.env.VUE_APP_NAME_ID}_account`);
            } else {
                const { value } = await Preferences.get({ key: `${process.env.VUE_APP_NAME_ID}_account` });
                return value ? JSON.parse(value) : null;
            }
        } catch (error) {
            console.error('Error fetching account:', error);
            return null;
        }
    },
    setAccount: async (account = null) => {
        try {
            if (await Device.getPlatform() === 'web') {
                ls.set(`${process.env.VUE_APP_NAME_ID}_account`, account);
            } else {
                await Preferences.set({
                    key: `${process.env.VUE_APP_NAME_ID}_account`,
                    value: JSON.stringify(account)
                });
            }
        } catch (error) {
            console.error('Error saving account:', error);
        }
    },
    clear: async () => {
        try {
            await Storage.setUser(null);
            await Storage.setAccount(null);
        } catch (error) {
            console.error('Error clearing data:', error);
        }
    },
    getCredentials: async () => {
        try {
            if (await Device.getPlatform() === 'web') {
                return ls.get(`${process.env.VUE_APP_NAME_ID}_credentials`);
            } else {
                const { value } = await Preferences.get({ key: `${process.env.VUE_APP_NAME_ID}_credentials` });
                return value ? JSON.parse(value) : null;
            }
        } catch (error) {
            console.error('Error fetching credentials:', error);
            return null;
        }
    },
    setCredentials: async (credentials = null) => {
        try {
            if (await Device.getPlatform() === 'web') {
                ls.set(`${process.env.VUE_APP_NAME_ID}_credentials`, credentials);
            } else {
                await Preferences.set({
                    key: `${process.env.VUE_APP_NAME_ID}_credentials`,
                    value: JSON.stringify(credentials)
                });
            }
        } catch (error) {
            console.error('Error saving credentials:', error);
        }
    },
};
